import { ClockCircleFilled } from "@ant-design/icons";
import React from "react";
import { $t } from "~/i18n.js";
import { colors } from "~/theme/colors.js";

export const BevoegdheidExpirationWarning = ({ bevoegdheid }) => {
  if (!bevoegdheid.behaald.date_assigned || !bevoegdheid.behaald.date_geldig)
    return null;

  const nearly_invalid = bevoegdheid.behaald.days_left < (bevoegdheid.days_warning || 30);
  return (
    <>
      <span className="gray" style={{ marginLeft: 12 }}>
        {nearly_invalid && (
          <ClockCircleFilled style={{ color: colors.orange, marginRight: 2 }} />
        )}

        {bevoegdheid.behaald.days_left <= 0 ? (
          <span>{$t("verlopen")}</span>
        ) : (
          <span>
            {bevoegdheid.behaald.days_left} {$t("dagen")}
          </span>
        )}

        {!nearly_invalid && bevoegdheid.behaald.remark && (
          <span className="gray" style={{ marginLeft: 6 }}>
            - {bevoegdheid.behaald.remark}
          </span>
        )}
      </span>
    </>
  );
};
